/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import moment from "moment";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { Auth, getBearerToken } from "../Authentication/Auth";
import {
  appendIPFSBaseUrl,
  checkEvenOddInArray,
  commonMessages,
  decryptValue,
  errorMessages,
  extractIPFSPrefix,
  GenesisTypes,
  isEmptyObject,
  isUndefined,
  metamaskErrorMessages,
  notificationPosition,
  notificationSetting,
  notificationType,
  notUndefined,
  showNotification,
} from "../Common";
import { SwitchLoader } from "../Common/AxiosConfiguration";
import { loaderType, StartLoader, StopLoader } from "../Common/Loader";
import { GlobalModal, GlobalTooltip } from "../Global";
import useWalletChange from "../hooks/useWalletChange";
import {
  getBabyTotalValues,
  getBaseURI,
  getRequiredTokenForSuperBabies,
  getWalletOfOwner,
  getWalletOfOwnerBaby,
  mintNFTBaby,
  mintNFTSuperBaby,
  publicSaleStatusBaby,
} from "../Scripts/interact";
import { TokenHolderService } from "../Services";
import { BabyMintingService } from "../Services/BabyMintingService";
import { SelectionContainer } from "../SubComponents/SelectionContainer";
import { DataNotFound } from "../SubSection/DataNotFound";
import { LoadingSection } from "../SubSection/LoadingSection";
import { MintButton } from "../SubSection/MintButton";
import { DndContainer } from "../Testing/DndContainer";
import { ShowTime } from "./ShowTime";
import { StartTimer } from "./StartTimer";

const BabyMint = () => {
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [serverToken, setServerToken] = useState(null);
  const [walletOfOwner, setWalletOfOwner] = useState([]);
  const [walletOfOwnerBaby, setWalletOfOwnerBaby] = useState([]);
  const [totalValuesOfBaby, setTotalValuesOfBaby] = useState({});
  const [requiredTokenForSuperBabies, setRequiredTokenForSuperBabies] =
    useState();
  const [baseURI, setBaseURI] = useState("");
  const [isBabyPublicSaleOn, setIsBabyPublicSaleOn] = useState(false);
  const [saleStartedOn, setSaleStartedOn] = useState();
  const [selectedGenesis, setSelectedGenesis] = useState({});
  const [defaultGenesisPair, setDefaultGenesisPair] = useState([]);
  const [genesisList, setGenesisList] = useState([]);
  const [merkleData, setMerkleData] = useState({});
  const [activeGenesisPair, setActiveGenesisPair] = useState({});
  const { isWalletConnected, changedAddress } = useWalletChange();
  const [currentDay, setCurrentDay] = useState({});
  const [modal, setModal] = useState({
    dragAndDropModal: false,
    videoModal: false,
  });
  const [displayCloseButton, setDisplayCloseButton] = useState(false);
  const quantity = 1;
  const totalEthers = 0;
  const unmount = useRef();
  const babyChamberRef = useRef();
  const videoRef = useRef();
  const env = process.env.NODE_ENV;

  // const changedAddress = "0xCB5990CE9b50E1A207F10fcd52471073C65DaC24"; //For Testing
  useEffect(() => {
    if (isWalletConnected) {
      SwitchLoader(loaderType.COMMON, "Please Wait");
      handleLogin();
    }
  }, [isWalletConnected]);

  useEffect(() => {
    const checkUndefinedAddress = async () => {
      if (notUndefined(changedAddress)) {
        handleNodeLogin();
        if (env === "production") {
          console.log("Production Mode");
          getWalletofOwnerDetails();
        } else {
          console.log("Development Mode");
          getWalletofOwnerFromServer();
        }
        getBabyWalletofOwnerDetails();
        getRequiredTokenForSuperBaby();
        getBabyPublicSaleStatus();
        const totalValues = await getBabyTotalValuesFromContract();
      }
    };

    checkUndefinedAddress().catch(console.error);
    return () => {
      unmount.current = true;
    };
  }, [changedAddress]);

  useEffect(() => {
    const getAndSetData = async () => {
      if (
        notUndefined(changedAddress) &&
        notUndefined(getBearerToken().bearerToken) &&
        walletOfOwner.length > 0
        // && notUndefined(baseURI)
      ) {
        const allTokens = getGenesisToken();

        getAddressMerkleHash();
        // setIPFSImageData(allTokens);
      }
    };
    getAndSetData().catch(console.error);
  }, [
    changedAddress,
    getBearerToken().bearerToken,
    // baseURI,
    walletOfOwner,
  ]);

  /* Getters */

  const getWalletofOwnerDetails = async () => {
    const response = await getWalletOfOwner(changedAddress);
    // console.log("Wallet of Owner By Contract: ", response);
    if (response?.status) {
      if (notUndefined(response?.wallet) && response?.wallet.length > 0) {
        // console.log("Child Wallet: ",response)
        setWalletOfOwner(response?.wallet);
        return response?.wallet;
      } else {
        return [];
      }
    } else {
      showNotification(
        notificationType.DANGER,
        response.message,
        notificationSetting
      );
    }
  };

  const getBabyWalletofOwnerDetails = async () => {
    const response = await getWalletOfOwnerBaby(changedAddress);
    // console.log("Wallet of Baby Owner By Contract: ", response);
    if (response?.status) {
      if (notUndefined(response?.wallet) && response?.wallet.length > 0) {
        // console.log("Child Wallet: ",response)
        setWalletOfOwnerBaby(response?.wallet);
        return response?.wallet;
      } else {
        return [];
      }
    } else {
      showNotification(
        notificationType.DANGER,
        response.message,
        notificationSetting
      );
    }
  };

  const getBabyTotalValuesFromContract = async () => {
    const response = await getBabyTotalValues();

    if (response?.status) {
      setTotalValuesOfBaby({
        totalSupply: response?.totalSupply,
        maxGenCount: response?.maxGenCount,
        maxPerMintToken: response?.maxPerMintToken,
      });
      return response;
    } else {
      showNotification(
        notificationType.DANGER,
        response.message,
        notificationSetting
      );
    }
  };

  const getRequiredTokenForSuperBaby = async () => {
    const response = await getRequiredTokenForSuperBabies();

    if (response?.status) {
      setRequiredTokenForSuperBabies(response?.requireTokens);
      return response;
    } else {
      showNotification(
        notificationType.DANGER,
        response.message,
        notificationSetting
      );
    }
  };

  const getBabyPublicSaleStatus = async () => {
    const response = await publicSaleStatusBaby();
    if (response?.status) {
      setIsBabyPublicSaleOn(response?.publicSale);
    } else {
      showNotification(
        notificationType.DANGER,
        response.message,
        notificationSetting
      );
    }
  };

  const getWalletofOwnerFromServer = async () => {
    BabyMintingService.getWalletOfOwnerFromServer({
      wallet_address: changedAddress,
    }).then((response) => {
      if (response?.status === false) {
        showNotification(
          notificationType.DANGER,
          response.message,
          notificationSetting
        );
      } else if (response?.status === true) {
        // console.log("Wallet of Owner By Server: ", response?.data);
        setWalletOfOwner(response?.data);
      }
    });
  };

  const getBaseURIFromContract = async () => {
    const response = await getBaseURI();
    if (response?.status) {
      // console.log(
      //   "Base URI: ",
      //   appendIPFSBaseUrl(extractIPFSPrefix(response?.baseURI))
      // );
      setBaseURI(() => {
        return appendIPFSBaseUrl(extractIPFSPrefix(response?.baseURI));
      });
    } else {
      showNotification(
        notificationType.DANGER,
        response?.message,
        notificationSetting
      );
    }
  };

  const checkTokenExist = (tokenId) => {
    return walletOfOwner.indexOf(parseInt(tokenId)) === -1 ? false : true;
  };

  const allTokensMinted = () => {
    return totalValuesOfBaby?.totalSupply >= totalValuesOfBaby?.maxGenCount
      ? true
      : false;
  };

  const getGenesisToken = async () => {
    SwitchLoader(loaderType.COMMON, "Please Wait, Genesis Loading");
    let allTokens = await BabyMintingService.getGenesisToken({
      wallet_address: changedAddress,
      // wallet_address: "0x60Ac67b3a98CbEEC24B489603cFF65EdaBf138E8",
    }).then((response) => {
      if (response?.status === false) {
        showNotification(
          notificationType.DANGER,
          response.message,
          notificationSetting
        );
      } else if (response?.status === true) {
        setIPFSImageData(response?.data);
        return response?.data;
      }
    });

    return allTokens;
  };

  const checkForMint = (pair) => {
    let flag = false;
    // console.log("Pair: ", pair);
    if (!allTokensMinted() && pair?.is_can_baby_mint === true) {
      // console.log("Pair If: ", pair);
      if (pair?.token1Exist && pair?.token2Exist) {
        // console.log("Pair If -> If: ", pair);
        flag = true;
      }
    }
    return flag;
  };

  const checkForChange = (pair, tokenType) => {
    let flag = false;
    // console.log("Pair: ", pair);
    //Previous Condition
    // if (!allTokensMinted() && pair?.is_can_baby_mint === true) {
    // Manoj Sir told to Change the Condition to token_minted.length = 0 then button show
    if (!allTokensMinted() && pair?.token_minted.length === 0) {
      if (
        pair?.token1Exist &&
        walletOfOwner.indexOf(parseInt(pair?.male_token_id)) !== -1 &&
        pair?.token2Exist &&
        walletOfOwner.indexOf(parseInt(pair?.female_token_id)) !== -1
      ) {
        // console.log("Pair If -> If: ", pair);
        flag = true;
      }
      //Previous Condition, Manoj Sir told to Uncomment it again
      else if (
        (tokenType === 1 && pair?.token1Exist && !pair?.token2Exist) ||
        (tokenType === 0 && !pair?.token1Exist && pair?.token2Exist)
      ) {
        // flag = true;
        flag = false; //Part of Discussion
      }
      // Manoj Sir told to Replace the Condition by below
      // else if (
      //   (tokenType === 1 && pair?.token2Exist) ||
      //   (tokenType === 0 && pair?.token1Exist)
      // ) {
      //   flag = true;
      // }
    }
    return flag;
  };

  const canMint = (pair) => {
    let flag = false;
    if (!allTokensMinted() && isBabyPublicSaleOn) {
      if (pair?.is_can_baby_mint === true) {
        // console.log("Pair If: ", pair);
        if (pair?.token1Exist && pair?.token2Exist) {
          // console.log("Pair If -> If: ", pair);
          flag = true;
        }
      }
    }

    return flag;
  };

  const isSuperBabyShown = () => {
    let flag = false;
    if (
      walletOfOwnerBaby.length >= requiredTokenForSuperBabies &&
      parseInt(process.env.REACT_APP_SUPER_BABY_MINT_BUTTON_DISPLAY) === 1
    ) {
      flag = true;
    }

    return flag;
  };

  const messageForCannotMint = (pair) => {
    let message = "";

    if (allTokensMinted()) {
      message = `All Tokens Minted`;
    } else if (isBabyPublicSaleOn) {
      if (pair?.is_can_baby_mint) {
        if (!pair?.token1Exist) {
          message = `${commonMessages.messageCustom} ${
            pair?.male_token_gender
              ? pair?.male_token_gender
              : GenesisTypes.MALE
          } ${commonMessages.toFuseBaby}`;
        } else if (!pair?.token2Exist) {
          message = `${commonMessages.messageCustom} ${
            pair?.female_token_gender
              ? pair?.female_token_gender
              : GenesisTypes.FEMALE
          } ${commonMessages.toFuseBaby}`;
        }
      } else if (
        !pair?.is_can_baby_mint &&
        pair?.got_both_tokens === "1" &&
        pair?.token1Exist &&
        pair?.token2Exist
      ) {
        if (
          parseInt(moment(pair?.can_baby_mint_on).diff(moment(), "days") + 1) <=
          1
        ) {
          message = (
            <StartTimer
              message={`${commonMessages.readyToFuse} ${pair?.baby_num} in `}
              comparisionDate={pair?.can_baby_mint_on}
            />
          );
        } else {
          message = `${commonMessages.readyToFuse} ${pair?.baby_num} in ${
            moment(pair?.can_baby_mint_on).diff(moment(), "days") + 1
          } Day(s)`;
        }
      }
    } else {
      if (isUndefined(saleStartedOn)) {
        message = commonMessages.saleCommingSoon;
      } else {
        message = `${commonMessages.saleWillStartOn} ${saleStartedOn}`;
      }
    }

    return <span className="badge bg-primary">{message}</span>;
  };

  const prepareAnchorForBaby = (pair) => {
    let props = {};
    if (pair.baby_no === null || pair.baby_no === 0) {
      props.className = "clickable";
    } else {
      props.href = process.env.REACT_APP_BABY_OPENSEA;
      props.target = "_blank";
      props.rel = "noreferrer";
    }
    return (
      <a {...props}>
        <img src={prepareBabyImagePath(pair)} className="img-fluid" alt="" />
      </a>
    );
  };

  const prepareBabyImagePath = (pair) => {
    let path = "assets/images/SC-babymint.gif";

    if (pair.baby_no === null) {
      path = "assets/images/question-mark.svg";
    } else if (pair.baby_no > 0) {
      if (notUndefined(pair?.baby_token_image)) {
        path = pair?.baby_token_image;
      }
    }
    return path;
  };

  const prepareBabyTokenMessage = (pair) => {
    let tokenNo = `Token No.: ${pair?.baby_no}`;
    if (pair.baby_no === null) tokenNo = "Transaction Pending";

    return tokenNo;
  };

  const showReadyToFuse = (pair) => {
    let message = commonMessages.readyToFuse;
    let flag = 0;
    let purchasable = 0;
    if (allTokensMinted()) {
      flag = 1;
      message = `All Tokens Minted`;
    } else if (
      !pair?.is_can_baby_mint &&
      pair?.got_both_tokens === "1" &&
      pair?.token1Exist &&
      pair?.token2Exist
    ) {
      flag = 1;
      // message = `${message} ${pair?.baby_num} in ${moment(
      //   pair?.can_baby_mint_on
      // ).diff(moment(), "days")} Day(s)`;
      if (
        parseInt(moment(pair?.can_baby_mint_on).diff(moment(), "days")) <= 1
      ) {
        message = (
          <ShowTime
            message={`${message} ${pair?.baby_num} in `}
            comparisionDate={pair?.can_baby_mint_on}
          />
        );
      } else {
        message = `${message} ${pair?.baby_num} in ${
          moment(pair?.can_baby_mint_on).diff(moment(), "days") + 1
        } Day(s)`;
      }

      // if (pair?.baby_num > 0 && pair?.token1Exist && pair?.token2Exist) {
      //   message = `${message} Child No. ${pair?.baby_num} in ${moment(
      //     pair?.can_baby_mint_on
      //   ).diff(moment(), "days")} Day(s)`;
      //   flag = 1;
      // }
    } else if (
      pair?.is_can_baby_mint &&
      pair?.got_both_tokens === "1" &&
      pair?.token1Exist &&
      pair?.token2Exist
    ) {
      flag = 1;
      message = `${message} ${pair?.baby_num}`;
    } else {
      if (!pair?.token1Exist) {
        message = `${commonMessages.messageCustom} ${
          pair?.male_token_gender ? pair?.male_token_gender : GenesisTypes.MALE
        } ${commonMessages.toFuseBaby}`;
        purchasable = 1;
      } else if (!pair?.token2Exist) {
        message = `${commonMessages.messageCustom} ${
          pair?.female_token_gender
            ? pair?.female_token_gender
            : GenesisTypes.FEMALE
        } ${commonMessages.toFuseBaby}`;
        purchasable = 1;
      }
      flag = 1;
    }

    if (flag === 1) {
      return purchasable === 1 ? (
        <a
          href={"https://opensea.io/collection/supercreatorsorigins"}
          target="_blank"
          rel="noreferrer"
          className="btn ready-btn clickable"
        >
          {message}
        </a>
      ) : (
        <a className="btn ready-btn clickable">{message}</a>
      );
    } else {
      return <></>;
    }
  };

  const setIPFSImageData = (allTokens) => {
    let notExist = [];
    allTokens.map((token, idx) => {
      let token1Exist = true,
        token2Exist = true;
      if (!checkTokenExist(token?.male_token_id)) {
        token1Exist = false;
        notExist.push(token?.male_token_id);
      }
      // // token.male_token_image = `https://ipfs.io/ipfs/QmdR3WxeouVCJjMVZLuSMTobsN3SNZquabHvHEW51JQV5a/${token?.male_token_id}.png`;
      else if (!checkTokenExist(token?.female_token_id)) {
        token2Exist = false;
        notExist.push(token?.female_token_id);
      }
      // token.female_token_image = `https://ipfs.io/ipfs/QmdR3WxeouVCJjMVZLuSMTobsN3SNZquabHvHEW51JQV5a/${token?.female_token_id}.png`;
      token.token1Exist = token1Exist;
      token.token2Exist = token2Exist;
    });
    setGenesisList(allTokens);
    processDefaultSelectedGenesis(allTokens);
    transferWalletAddress(notExist);
    // Promise.resolve()
    //   .then(() => {
    //     allTokens.map(async (token, idx) => {
    //       let token1Exist = false,
    //         token2Exist = false;
    //       // console.log(
    //       //   "Male Index: ",
    //       //   checkTokenExist(token?.male_token_id),
    //       //   token?.male_token_id
    //       // );
    //       // console.log("Wallet of Owner: ", walletOfOwner);
    //       // console.log("Male: ", await getIPFSImage(token?.male_token_id));
    //       // console.log(
    //       //   "Female Index: ",
    //       //   checkTokenExist(token?.female_token_id),
    //       //   token?.female_token_id
    //       // );
    //       // console.log("Female: ", await getIPFSImage(token?.female_token_id));

    //       if (checkTokenExist(token?.male_token_id)) {
    //         token1Exist = true;
    //       }
    //       token.male_token_image = await getIPFSImage(token?.male_token_id);
    //       if (checkTokenExist(token?.female_token_id)) {
    //         token2Exist = true;
    //       }
    //       token.female_token_image = await getIPFSImage(token?.female_token_id);
    //       token.token1Exist = token1Exist;
    //       token.token2Exist = token2Exist;
    //     });
    //   })
    //   // .then(() => {
    //   //   console.log("Data: ", allTokens);
    //   // })
    //   .finally(() => {
    //     setGenesisList(allTokens);
    //   });
  };

  const getIPFSImage = async (tokenNo) => {
    let image = await TokenHolderService.getIPFSData(
      `${baseURI}${tokenNo}.json`
    ).then((response) => {
      return appendIPFSBaseUrl(extractIPFSPrefix(response?.data?.image));
    });
    return image;
  };

  /* Setters */

  const handleLogin = () => {
    let newForm = {
      email: process.env.REACT_APP_API_LOGIN_UNAME,
      password: process.env.REACT_APP_API_LOGIN_PWD,
    };
    BabyMintingService.getServerLogin({ ...newForm }).then((response) => {
      if (response?.status === false) {
        showNotification(
          notificationType.DANGER,
          response.message,
          notificationSetting
        );
      } else if (response?.status === true) {
        Auth.authenticateServerData(response?.token);
        setServerToken(response?.token);
        setSaleStartedOn(response?.sale_start_on);
        setCurrentDay(response?.data?.currentday);
      }
    });
  };

  const handleNodeLogin = () => {
    let newForm = {
      username: process.env.REACT_APP_NODE_LOGIN_UNAME,
      secret: process.env.REACT_APP_NODE_LOGIN_SECRET,
    };
    BabyMintingService.getNodeLogin({ ...newForm }).then((response) => {
      if (response?.status === false) {
        showNotification(
          notificationType.DANGER,
          response.message,
          notificationSetting
        );
      } else if (response?.status === true) {
        Auth.authenticateNodeData(response?.access_token);
      }
    });
  };

  const getAddressMerkleHash = () => {
    setMerkleData({});
    BabyMintingService.generateAddressHash({
      // wallet_address: "0x60Ac67b3a98CbEEC24B489603cFF65EdaBf138E8",
      wallet_address: changedAddress,
    }).then((response) => {
      if (response?.status === false) {
        showNotification(
          notificationType.DANGER,
          response.message,
          notificationSetting
        );
        StopLoader(loaderType.BUTTON);
        setButtonDisabled(false);
      } else if (response?.status === true) {
        const decryptedRootHash = decryptValue(response?.rootHash);
        const decryptedAddressHash = decryptValue(response?.hashProof).split(
          ","
        );

        setMerkleData({
          merkleHash: decryptedAddressHash,
          rootHash: decryptedRootHash,
        });
      }
    });
  };

  const processDefaultSelectedGenesis = (allTokens) => {
    let selectable = allTokens.filter(function (o) {
      return (
        parseInt(o.baby_num) > 0 &&
        parseInt(o.got_both_tokens) === 1 &&
        o.is_can_baby_mint &&
        o.token1Exist &&
        o.token2Exist
      );
    });

    let obj = {};
    if (selectable.length > 0) {
      obj = selectable[0];
    } else {
      obj = allTokens[0];
    }
    setSelectedGenesis(obj);
    StopLoader(loaderType.COMMON);
  };

  const selectGenesis = (genesis_id) => {
    let selectable = genesisList.filter(function (o) {
      return parseInt(o.id) === parseInt(genesis_id);
    })[0];

    setSelectedGenesis(selectable);
    babyChamberRef.current.scrollIntoView();
    // window.scrollTo(0, 280);
  };

  const manageChangingGenesis = (genesis, genesis_type, genesis_index) => {
    let selectable = genesisList.filter(function (o) {
      return parseInt(o.id) === parseInt(genesis.id);
    })[0];
    // console.log({
    //   ...selectable,
    //   genesis: [
    //     {
    //       image: selectable?.female_token_image,
    //       token_id: selectable?.female_token_id,
    //       txDate: selectable?.female_token_ownership_date,
    //       genesisType: selectable?.female_token_gender,
    //       genesisIndex: 0,
    //     },
    //     {
    //       image: selectable?.male_token_image,
    //       token_id: selectable?.male_token_id,
    //       txDate: selectable?.male_token_ownership_date,
    //       genesisType: selectable?.male_token_gender,
    //       genesisIndex: 1,
    //     },
    //   ],
    //   activeIndex: genesis_index,
    //   active: genesis_type,
    // });

    const defaultPair = [
      {
        image: selectable?.female_token_image,
        token_id: selectable?.female_token_id,
        txdate: selectable?.female_token_ownership_date,
        genesisType: selectable?.female_token_gender,
        genesisIndex: 0,
      },
      {
        image: selectable?.male_token_image,
        token_id: selectable?.male_token_id,
        txdate: selectable?.male_token_ownership_date,
        genesisType: selectable?.male_token_gender,
        genesisIndex: 1,
      },
    ];
    setActiveGenesisPair({
      ...selectable,
      genesis: defaultPair,
      activeIndex: genesis_index,
      active: genesis_type,
    });
    setDefaultGenesisPair([...defaultPair]);
    handleModalOpen("drag_and_drop_modal");
    // window.scrollTo(0, 280);
  };

  const transferWalletAddress = (notMintedTokens) => {
    let newForm = {
      wallet_address: changedAddress,
      not_exist_tokens: notMintedTokens.toString(),
    };
    BabyMintingService.walletAddressTransfer({ ...newForm }).then(
      (response) => {
        if (response?.status === false) {
          console.warn("Error in Address Transfer API: ", response?.message);
          // showNotification(
          //   notificationType.DANGER,
          //   response.message,
          //   notificationSetting
          // );
        } else if (response?.status === true) {
          console.log("Response Transfer:", response);
        }
      }
    );
  };

  const mintNFTPressed = async (event) => {
    event.preventDefault();
    let mint_id;
    StartLoader(loaderType.BUTTON);
    setButtonDisabled(true);
    if (!isEmptyObject(merkleData) && notUndefined(merkleData?.merkleHash)) {
      mint_id = await addMintEntry(
        selectedGenesis?.female_token_id,
        selectedGenesis?.male_token_id
      );
      if (notUndefined(mint_id)) {
        StartLoader(loaderType.BUTTON);
        setButtonDisabled(true);
        const { status, message, fullMessage, hash } = await mintNFTBaby(
          quantity,
          totalEthers,
          merkleData?.merkleHash
        );
        if (status) {
          StopLoader(loaderType.BUTTON);
          setButtonDisabled(false);
          showNotification(notificationType.SUCCESS, message, {
            title: "Minting Successful",
            duration: 6000,
            notificationPosition: notificationPosition.BOTTOM_RIGHT,
          });

          let babyTokens = await getBabyWalletofOwnerDetails();
          if (babyTokens.length > 0) {
            let latestBabyToken = babyTokens[babyTokens.length - 1];
            manageMintEntry(
              "UPDATE",
              mint_id,
              selectedGenesis?.female_token_id,
              selectedGenesis?.male_token_id,
              hash,
              latestBabyToken
            );
          }
        } else {
          StopLoader(loaderType.BUTTON);
          setButtonDisabled(false);
          console.error(message);
          showNotification(
            notificationType.DANGER,
            message,
            notificationSetting
          );
          manageErrorLog(mint_id, fullMessage);
          manageMintEntry(
            "DELETE",
            mint_id,
            selectedGenesis?.female_token_id,
            selectedGenesis?.male_token_id,
            hash,
            0
          );
        }
      }
    } else {
      StopLoader(loaderType.BUTTON);
      setButtonDisabled(false);
      showNotification(
        notificationType.DANGER,
        "Hash is Not Available for this Wallet Address",
        notificationSetting
      );
      getAddressMerkleHash();
    }
  };

  const mintSuperBabyNFTPressed = async (event) => {
    event.preventDefault();
    if (walletOfOwnerBaby.length < 5) return;
    // let mint_id;
    // console.log("Wallet of Owner Baby: ", walletOfOwnerBaby);
    // walletOfOwnerBaby.reduceRight((_, item) => console.log("Item", item), null);

    const num = 5500;
    let filteredArray = walletOfOwnerBaby.filter((n) => n <= num);

    if (filteredArray.length < 5) {
      showNotification(
        notificationType.DANGER,
        "Minimum 5 Tokens Required to Perform this action",
        notificationSetting
      );
      return;
    }

    StartLoader(loaderType.BUTTON);
    setButtonDisabled(true);
    if (!isEmptyObject(merkleData) && notUndefined(merkleData?.merkleHash)) {
      // mint_id = await addMintEntry(
      //   selectedGenesis?.female_token_id,
      //   selectedGenesis?.male_token_id
      // );
      // if (notUndefined(mint_id)) {
      StartLoader(loaderType.BUTTON);
      setButtonDisabled(true);
      const { status, message, hash } = await mintNFTSuperBaby(
        quantity,
        totalEthers,
        filteredArray.slice(0, requiredTokenForSuperBabies),
        merkleData?.merkleHash
      );
      if (status) {
        StopLoader(loaderType.BUTTON);
        setButtonDisabled(false);
        showNotification(notificationType.SUCCESS, message, {
          title: "Minting Successful",
          duration: 6000,
          notificationPosition: notificationPosition.BOTTOM_RIGHT,
        });

        // let babyTokens = await getBabyWalletofOwnerDetails();
        // if (babyTokens.length > 0) {
        //   let latestBabyToken = babyTokens[babyTokens.length - 1];
        //   manageMintEntry(
        //     "UPDATE",
        //     mint_id,
        //     selectedGenesis?.female_token_id,
        //     selectedGenesis?.male_token_id,
        //     hash,
        //     latestBabyToken
        //   );
        // }
      } else {
        StopLoader(loaderType.BUTTON);
        setButtonDisabled(false);
        console.error(message);
        showNotification(notificationType.DANGER, message, notificationSetting);

        // manageMintEntry(
        //   "DELETE",
        //   mint_id,
        //   selectedGenesis?.female_token_id,
        //   selectedGenesis?.male_token_id,
        //   hash,
        //   0
        // );
      }
      // }
    } else {
      StopLoader(loaderType.BUTTON);
      setButtonDisabled(false);
      showNotification(
        notificationType.DANGER,
        "Hash is Not Available for this Wallet Address",
        notificationSetting
      );
      getAddressMerkleHash();
    }
  };

  const addMintEntry = async (female_token_id, male_token_id) => {
    let mint_id;
    let tempObject = {
      wallet_address: changedAddress,
      // wallet_address: "0x60Ac67b3a98CbEEC24B489603cFF65EdaBf138E8",
      count: quantity,
      status: 0,
      txn_hash: "",
      female_token_id: female_token_id,
      male_token_id: male_token_id,
    };
    unmount.current = false;
    await BabyMintingService.addMint(tempObject).then((response) => {
      if (unmount.current === true) return;
      if (response.status) {
        mint_id = response?.data?.minted?.id;
      } else {
        setButtonDisabled(false);
        showNotification(
          notificationType.ERROR,
          response.message,
          notificationSetting
        );
        mint_id = "";
      }
    });
    // console.log("ID:", mint_id);
    return mint_id;
  };

  const manageMintEntry = (
    operationType,
    mint_id,
    female_token_id,
    male_token_id,
    txnHash,
    baby_no
  ) => {
    // let status;
    let tempObject = {
      wallet_address: changedAddress,
      // wallet_address: "0x60Ac67b3a98CbEEC24B489603cFF65EdaBf138E8",
      count: quantity,
      txn_hash: txnHash,
      status: operationType === "UPDATE" ? 1 : operationType === "DELETE" && 2,
      mint_id: mint_id,
      female_token_id: female_token_id,
      male_token_id: male_token_id,
      baby_no: operationType === "UPDATE" ? baby_no : "",
    };

    unmount.current = false;
    BabyMintingService.addMint(tempObject).then((response) => {
      if (unmount.current === true) return;
      if (response.status) {
        // status = true;
        console.log(`Entry ${operationType}ed Hash:${txnHash} ID:${mint_id}`);
        if (operationType === "UPDATE") {
          // window.location.reload();
          handleModalOpen("video_modal");
          playVideo();
        }
      } else {
        console.error("Error Adding Data : ", response.message);
        // if(response?.data?.baby_already_attached){

        // }
        setButtonDisabled(false);
        showNotification(
          notificationType.ERROR,
          response.message,
          notificationSetting
        );
        // status = false;
      }
      // getTokenType();
    });
  };

  const manageErrorLog = (mint_id, error) => {
    // let status;
    let tempObject = {
      wallet_address: changedAddress,
      // wallet_address: "0x60Ac67b3a98CbEEC24B489603cFF65EdaBf138E8",
      mint_id: mint_id,
      error: error,
    };

    unmount.current = false;
    BabyMintingService.manageErrorLog(tempObject).then((response) => {
      if (unmount.current === true) return;
      if (response.status) {
        console.log(`Log Added`);
      } else {
        console.error("Error Adding Log : ", response.message);
      }
    });
  };
  // Handlers

  const handleModalOpen = (modalName, ...rest) => {
    let keyName = "";
    switch (true) {
      case modalName === "drag_and_drop_modal":
        keyName = "dragAndDropModal";
        break;
      case modalName === "video_modal":
        keyName = "videoModal";
        break;
      default:
        keyName = "";
    }
    if (keyName !== "") {
      setModal({ ...modal, [keyName]: true });
    }
  };

  const handleModalClose = (modalName) => {
    let keyName = "";
    switch (true) {
      case modalName === "drag_and_drop_modal":
        keyName = "dragAndDropModal";
        break;
      case modalName === "video_modal":
        keyName = "videoModal";
        window.location.reload();
        break;
      default:
        keyName = "";
    }
    if (keyName !== "") {
      setModal({ ...modal, [keyName]: false });
    }
  };

  const refreshDataOnUpdateGenesis = async () => {
    handleModalClose("drag_and_drop_modal");
    let all = getGenesisToken();
  };

  const playVideo = () => {
    if (notUndefined(videoRef.current)) {
      console.log("Video Ref: ", videoRef.current);
      videoRef.current.play();
    }
  };
  return (
    <>
      {isWalletConnected && (
        <>
          <section ref={babyChamberRef} className="baby-chamber section">
            <div className="container">
              <h2>Junior - Divine Fusion Chamber</h2>
              <div className="subtitle">
                {" "}
                Select 1 Genesis Male and 1 Genesis Female Super Creator to
                Manifest a Super Creators Jr.{" "}
              </div>
              {
                // loading ? (
                //   <LoadingSection />
                // ) : (
                !isEmptyObject(selectedGenesis) ? (
                  <div className="baby-chamber-row">
                    <div
                      className="chamber-list baby-part-1 text-center wow fadeInDown"
                      data-wow-delay="0.2s"
                      style={{
                        visibility: "visible",
                        animationDelay: "0.2s",
                      }}
                    >
                      <div className="chamber-item">
                        <div className="img-cha">
                          <img
                            src={selectedGenesis?.female_token_image}
                            alt=""
                          />
                        </div>
                        <div className="title1">
                          {selectedGenesis?.female_token_gender}
                        </div>
                      </div>
                    </div>
                    <div
                      className="chamber-list baby-part-2 text-center wow fadeInDown"
                      data-wow-delay="0.2s"
                      style={{
                        visibility: "visible",
                        animationDelay: "0.2s",
                      }}
                    >
                      <div className="chamber-item">
                        <div className="img-cha">
                          <img src={selectedGenesis?.male_token_image} alt="" />
                        </div>
                        <div className="title1">
                          {selectedGenesis?.male_token_gender}
                        </div>
                      </div>
                    </div>
                    <div
                      className="chamber-list baby-part-3 text-center wow fadeInDown"
                      data-wow-delay="0.2s"
                      style={{
                        visibility: "visible",
                        animationDelay: "0.2s",
                      }}
                    >
                      <div className="chamber-item">
                        <div className="img-cha">
                          <img
                            className="quest-mark"
                            src="assets/images/SC-babymint.gif"
                            alt=""
                          />
                        </div>
                        <div className="title1">Junior</div>
                        {canMint(selectedGenesis) ? (
                          <MintButton
                            type={"button"}
                            className={"btn"}
                            onClick={mintNFTPressed}
                          >
                            Make Baby
                          </MintButton>
                        ) : (
                          messageForCannotMint(selectedGenesis)
                        )}
                        {isSuperBabyShown() && (
                          <MintButton
                            type={"button"}
                            className={"btn"}
                            onClick={mintSuperBabyNFTPressed}
                          >
                            Legendary
                          </MintButton>
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <DataNotFound message={errorMessages.noGenesisPairSelected} />
                )
              }
            </div>
          </section>
          <section className="baby-card">
            <div className="container">
              <h2>Your Super Creator Tokens</h2>
              <div className="subtitle">
                {" "}
                Your Super Creators accumulate divine manifestation energies
                over time. When they have collected enough,you can select a male
                and a female’s to fuse these energies to manifest a Super
                Creator Jr{" "}
              </div>
              {
                // loading ? (
                //   <LoadingSection />
                // ) : (
                <div className="row">
                  {genesisList.length > 0 ? (
                    genesisList.map((pair, idx) => (
                      <Fragment key={`pair-${idx}`}>
                        <div
                          className="col-xl-4 col-md-6 wow fadeInDown"
                          data-wow-delay="0.2s"
                          style={{
                            visibility: "visible",
                            animationDelay: "0.2s",
                          }}
                        >
                          {showReadyToFuse(pair)}
                          {/* {checkForMint(pair) && (
                              <a className="btn ready-btn clickable">
                                Ready to Fuse
                              </a>
                            )} */}
                          <div className="token-item">
                            <div className="token-flex">
                              <div className="img-token">
                                <img
                                  src={
                                    notUndefined(pair?.female_token_image) &&
                                    pair?.token2Exist
                                      ? pair?.female_token_image
                                      : "assets/images/question-mark.svg"
                                  }
                                  className="img-fluid"
                                  alt=""
                                />
                                <div className="title1 mb-2">
                                  {pair?.female_token_gender
                                    ? pair?.female_token_gender
                                    : GenesisTypes.FEMALE}
                                </div>
                                {checkForChange(pair, 1) && (
                                  <>
                                    <button
                                      className="btn"
                                      onClick={() => {
                                        manageChangingGenesis(
                                          pair,
                                          pair?.female_token_gender
                                            ? pair?.female_token_gender
                                            : GenesisTypes.FEMALE,
                                          0
                                        );
                                      }}
                                      disabled={buttonDisabled}
                                    >
                                      <i className="bi bi-pencil"></i> Change
                                    </button>{" "}
                                    <GlobalTooltip
                                      text={commonMessages.genesisTooltip}
                                    >
                                      <i className="bi bi-info-circle-fill clickable"></i>
                                    </GlobalTooltip>
                                  </>
                                )}
                              </div>

                              <div className="img-token">
                                <img
                                  src={
                                    notUndefined(pair?.male_token_image) &&
                                    pair?.token1Exist
                                      ? pair?.male_token_image
                                      : "assets/images/question-mark.svg"
                                  }
                                  className="img-fluid"
                                  alt=""
                                />
                                <div className="title1 mb-2">
                                  {pair?.male_token_gender
                                    ? pair?.male_token_gender
                                    : GenesisTypes.MALE}
                                </div>
                                {checkForChange(pair, 0) && (
                                  <>
                                    <button
                                      className="btn"
                                      onClick={() => {
                                        manageChangingGenesis(
                                          pair,
                                          pair?.male_token_gender
                                            ? pair?.male_token_gender
                                            : GenesisTypes.MALE,
                                          1
                                        );
                                      }}
                                      disabled={buttonDisabled}
                                    >
                                      <i className="bi bi-pencil"></i> Change
                                    </button>{" "}
                                    <GlobalTooltip
                                      text={commonMessages.genesisTooltip}
                                    >
                                      <i className="bi bi-info-circle-fill clickable"></i>
                                    </GlobalTooltip>
                                  </>
                                )}
                              </div>
                            </div>
                            {pair?.token_minted.length > 0 && (
                              <div
                                className="accordion"
                                id={`accordionBaby-${idx}`}
                              >
                                <div className="accordion-item">
                                  <h2
                                    className="accordion-header"
                                    id={`headingBaby-${idx}`}
                                  >
                                    <button
                                      className="accordion-button"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target={`#collapseBaby-${idx}`}
                                      aria-expanded="true"
                                      aria-controls={`collapseBaby-${idx}`}
                                    >
                                      Juniors Minted
                                    </button>
                                  </h2>
                                  <div
                                    id={`collapseBaby-${idx}`}
                                    className="accordion-collapse collapse"
                                    aria-labelledby={`headingBaby-${idx}`}
                                    data-bs-parent={`#accordionBaby-${idx}`}
                                  >
                                    <div className="accordion-body">
                                      {pair?.token_minted?.map(
                                        (mintedBaby, babyIdx) => (
                                          <Fragment key={`baby-${babyIdx}`}>
                                            <div className="img-token">
                                              {prepareAnchorForBaby(mintedBaby)}
                                              <div className="title1">
                                                {prepareBabyTokenMessage(
                                                  mintedBaby
                                                )}
                                              </div>
                                            </div>
                                          </Fragment>
                                        )
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="token-box-footer">
                            {/* <div className="title1">Genesis</div> */}
                            {checkForMint(pair) && (
                              <button
                                className="btn"
                                onClick={() => {
                                  selectGenesis(pair?.id);
                                }}
                                disabled={buttonDisabled}
                              >
                                Select
                              </button>
                            )}
                          </div>
                        </div>
                      </Fragment>
                    ))
                  ) : (
                    <div className="col-12">
                      <DataNotFound message={errorMessages.genesisNotFound} />
                    </div>
                  )}
                </div>

                //    : (
                //     <DataNotFound />
                //   )
              }
            </div>
          </section>

          <section className="faq section">
            <div className="container">
              <h2>FAQ’s</h2>
              {
                <div className="row">
                  <div className="container">
                    <div
                      className="accordion"
                      id="accordionPanelsStayOpenExample"
                    >
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#faq1"
                            aria-expanded="true"
                          >
                            What is the Divine Fusion Chamber?
                          </button>
                        </h2>
                        <div
                          id="faq1"
                          className="accordion-collapse collapse show"
                        >
                          <div className="accordion-body">
                            <ul>
                              <li>
                                This is where you can bring together a Super
                                Creators Genesis Male and Genesis Female to fuse
                                their manifestation energies to create a Super
                                Creators Jr.
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#faq2"
                            aria-expanded="false"
                          >
                            How Many Juniors (Babies) Can Be Minted?
                          </button>
                        </h2>
                        <div id="faq2" className="accordion-collapse collapse">
                          <div className="accordion-body">
                            <ul>
                              <li>
                                In total 5500 Super Creators Jr can be minted.
                              </li>
                              <li>
                                55 are Super Babies which can only be minted by
                                holding 5 Super Creators Jr tokens with each
                                element (Wind, Earth, Fire, Water, Space) for 90
                                Days.
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#faq3"
                            aria-expanded="false"
                          >
                            How do I Mint a Super Creators Jr?
                          </button>
                        </h2>
                        <div id="faq3" className="accordion-collapse collapse">
                          <div className="accordion-body">
                            <ul>
                              <li>
                                You must hold a Super Creator Genesis Male with
                                a Super Creator Genesis Female in your wallet
                                for 90 days.{" "}
                              </li>
                              <li>
                                After 90 days you'll be able to connect your
                                wallet on this page, select the pair of Super
                                Creators, and click to mint a Super Creators Jr.{" "}
                              </li>
                              <li>
                                If you continue to hold the same set of male and
                                female tokens, then the next Junior will only
                                take 60 days to mint, and subsequent Juniors
                                will take 30 days.{" "}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#faq4"
                            aria-expanded="false"
                          >
                            Why Should I Mint a Super Creators Jr?
                          </button>
                        </h2>
                        <div id="faq4" className="accordion-collapse collapse">
                          <div className="accordion-body">
                            <ul>
                              <li>
                                Super Creators Jr Provide the token holders with
                                the same benefits as holding a Super Creator
                                Genesis Token, the only difference is, Super
                                Creators Jr's are unable to make more babies.{" "}
                              </li>
                              <li>
                                That means, if you hold a Super Creators Jr,
                                then you'll also gain access to benefits such as
                                the Super Creators Academy.{" "}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#faq5"
                            aria-expanded="false"
                          >
                            What is the countdown?
                          </button>
                        </h2>
                        <div id="faq5" className="accordion-collapse collapse">
                          <div className="accordion-body">
                            <ul>
                              <li>
                                This is the amount of time remaining until the
                                genesis male and female Super creators must be
                                held in your wallet for, until they can manifest
                                a Super Creators Jr.
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#faq6"
                            aria-expanded="false"
                          >
                            Can I change my Super Creator Male and Female Pair
                            after They Have minted a Junior?
                          </button>
                        </h2>
                        <div id="faq6" className="accordion-collapse collapse">
                          <div className="accordion-body">
                            <ul>
                              <li>
                                After a pair of male and female Super Creators
                                have minted a Super Creators Junior, they will
                                want to remain together to mint more babies. As
                                a result, you're unable to separate them, to
                                pair them up with another Super Creator in your
                                wallet.{" "}
                              </li>
                              <li>
                                However, once you trade away one of the pairs,
                                the remaining Super Creator can then be paired
                                with another.{" "}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </section>

          {/* Modals */}
          {modal.dragAndDropModal && (
            <GlobalModal
              id={"drag-and-drop-modal"}
              isOpen={modal.dragAndDropModal}
              isCloseButtonDisplay={true}
              isHeaderDisplay={true}
              modalTitle={"Select Your Super Creator Pair"}
              dialogClassName={"modal-lg modal-dialog-centered"}
              modalId={"drag_and_drop"}
              onModalClose={(e) => handleModalClose("drag_and_drop_modal")}
            >
              <SelectionContainer
                currentDay={currentDay}
                defaultPair={defaultGenesisPair}
                genesisData={activeGenesisPair}
                handleGenesisSubmit={() => {
                  refreshDataOnUpdateGenesis();
                }}
              />
              {/* <DndContainer
                currentDay={currentDay}
                defaultPair={defaultGenesisPair}
                genesisData={activeGenesisPair}
                handleGenesisSubmit={() => {
                  refreshDataOnUpdateGenesis();
                }}
              /> */}
            </GlobalModal>
          )}

          {modal.videoModal && (
            <GlobalModal
              id={"video-modal"}
              isOpen={modal.videoModal}
              isCloseButtonDisplay={displayCloseButton}
              isHeaderDisplay={true}
              modalTitle={""}
              dialogClassName={"modal-lg modal-dialog-centered"}
              modalId={"video"}
              onModalClose={(e) => handleModalClose("video_modal")}
              backdrop="static"
              keyboard={false}
            >
              <video
                className="video-modal"
                width="100%"
                height="350"
                controls
                playsInline
                muted
                autoPlay={true}
                id={"videoId"}
                ref={videoRef}
                onEnded={() => {
                  setDisplayCloseButton(true);
                }}
              >
                <source
                  src="assets/images/SC Mating Video Attempt by Steve 2.mp4"
                  type="video/mp4"
                />
              </video>
              {/* <div className="text-center mt-3">
                <a
                  className="btn clickable"
                  onClick={() => handleModalClose("video_modal")}
                >
                  Ok
                </a>
              </div> */}
            </GlobalModal>
          )}
        </>
      )}
    </>
  );
};

export default BabyMint;
